// ============================================
// Main Entry Point
// ============================================

import { render } from 'preact';
import { LazyMotion, domAnimation } from 'framer-motion';
import { App } from './App';
import './index.css';

// ============================================
// Time-Based Theme (Optional)
// ============================================

function getTimeTheme(): string {
  const hour = new Date().getHours();

  if (hour >= 6 && hour < 12) return 'time-morning';
  if (hour >= 12 && hour < 17) return 'time-afternoon';
  if (hour >= 17 && hour < 20) return 'time-evening';
  return 'time-night';
}

function updateTimeTheme() {
  const html = document.documentElement;
  const classes = ['time-morning', 'time-afternoon', 'time-evening', 'time-night'];

  // Remove all time classes
  classes.forEach(cls => html.classList.remove(cls));

  // Add current time class
  html.classList.add(getTimeTheme());
}

// Update theme on load and every minute
updateTimeTheme();
setInterval(updateTimeTheme, 60 * 1000);

// ============================================
// Mount App
// ============================================

const root = document.getElementById('app');

if (root) {
  // LazyMotion with the `domAnimation` feature bundle lets every `m.*`
  // component tree-shake away the full `motion` featureset (drag/layout),
  // shrinking the framer-motion chunk on the critical path. `strict` throws
  // in dev if any legacy `motion.*` slips back in.
  render(
    <LazyMotion features={domAnimation} strict>
      <App />
    </LazyMotion>,
    root
  );
} else {
  console.error('Failed to find #app element');
}

// ============================================
// Debug Access (Development)
// ============================================

if (import.meta.env.DEV) {
  // Expose signals for debugging
  import('./state/signals').then(signals => {
    (window as unknown as { jlptApp: typeof signals }).jlptApp = signals;
    console.log('Debug: window.jlptApp available');
  });
}
